import React, { createContext } from 'react';
import { Version } from '@/config/versionConfig.definition';
import { getActiveVersion } from '@/config/versionConfig.service';

export type TVersion = Version;

export interface IVersionContext {
  version: TVersion;
}

export const VersionContext = createContext<IVersionContext | undefined>(undefined);

interface VersionProviderProps {
  children: React.ReactNode;
}

const VersionProvider = ({ children }: VersionProviderProps) => {
  const activeVersion = getActiveVersion();

  const value: IVersionContext = {
    version: activeVersion
  };

  return <VersionContext.Provider value={value}>{children}</VersionContext.Provider>;
};

export default VersionProvider;
